module.exports = __webpack_public_path__ + "static/media/irregular_pic.ed585359.svg";